import { post, put, get, del } from '@api/request';

export const fetchProperty = async (
  { litigationService },
  authenticationToken,
  { pID, pYear },
) => {
  const url = `${litigationService}/litigation/property/${pID}/${pYear}`;
  const { body } = await get(authenticationToken, url);
  return body;
};

export const fetchPropertyAssociations = async (
  { litigationService },
  authenticationToken,
  { caseID },
) => {
  const url = `${litigationService}/litigation/case/${caseID}/casepropassoc`;
  const { body } = await get(authenticationToken, url);
  return body;
};

export const fetchTaxingUnits = async (
  { litigationService },
  authenticationToken,
) => {
  const url = `${litigationService}/litigation/codes?caseType=litigation&type=case&name=taxingUnit`;
  const { body } = await get(authenticationToken, url);
  return body;
};

export const insertProperty = async (
  { litigationService },
  authenticationToken,
  { payload },
) => {
  const url = `${litigationService}/litigation/property`;
  const { body } = await post(authenticationToken, url, payload);
  return body;
};

export const insertPropertyAssociation = async (
  { litigationService },
  authenticationToken,
  { caseID, payload },
) => {
  const url = `${litigationService}/litigation/case/${caseID}/casepropassoc`;
  const { body } = await post(authenticationToken, url, payload);
  return body;
};

export const deletePropertyAssociation = async (
  { litigationService },
  authenticationToken,
  { assocID },
) => {
  const url = `${litigationService}/litigation/casepropassoc/${assocID}`;
  const { body } = await del(authenticationToken, url);
  return body;
};

export const updateProperty = async (
  { litigationService },
  authenticationToken,
  { payload },
) => {
  const { pID, pYear } = payload;
  const url = `${litigationService}/litigation/property/${pID}/${pYear}`;
  const { body } = await put(authenticationToken, url, payload);
  return body;
};

export const updatePropertyTaxingUnits = async (
  { litigationService },
  authenticationToken,
  { payload },
) => {
  const { pYear, pID } = payload;
  const url = `${litigationService}/litigation/property/${pID}/${pYear}/taxingunits`;
  const { body } = await put(authenticationToken, url, payload);
  return body;
};

export const setFinalValue = async (
  { litigationService },
  authenticationToken,
  { assocID, finalValue },
) => {
  const url = `${litigationService}/litigation/casepropassoc/${assocID}/setfinalvalue`;
  const { body } = await put(authenticationToken, url, { finalValue });
  return body;
};

export const setOpinionValue = async (
  { litigationService },
  authenticationToken,
  { assocID, ownerOpinionOfValue },
) => {
  const url = `${litigationService}/litigation/casepropassoc/${assocID}/setowneropinionofvalue`;
  const { body } = await put(authenticationToken, url, { ownerOpinionOfValue });
  return body;
};
